<template>
  <div class="LineUpContainer">
    <div class="white-box" v-if="!witnessFlag">
      <div class="queue">
        <div class="means-head-tit">见证/风险揭示双录</div>
        <div class="rigCon">
          <div class="con-left">
            <div class="timer" :style="timer">
              {{ transformTime(inLineTime) }}
            </div>
            <p class="inLine">
              排队中
              <span v-show="showLoad(inLineTime) >= 0">.</span>
              <span v-show="showLoad(inLineTime) >= 1">.</span>
              <span v-show="showLoad(inLineTime) >= 2">.</span>
              <span v-show="showLoad(inLineTime) >= 3">.</span>
              <span v-show="showLoad(inLineTime) >= 4">.</span>
            </p>
            <p>您当前排在队列第1位，请耐心等待！</p>
          </div>
          <div class="con-right">
            <div class="help-head">见证人员联系信息</div>
            <div class="help-body">
              <ul>
                <li class="li-title">
                  <span class="help-name" >姓名</span>
                  <span>座机</span>
                  <span>联系电话</span>
                </li>
                <li v-for="(item, index) in witnessesLinkInfo" :key="index">
                  <span class="help-name">{{ item.NAME }}</span>
                  <span>{{ item.TEL }}</span>
                  <span>{{ item.MOBILE_TEL }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="common-btns">
          <button class="save" @click="endQueue" v-show="!lineUpStatus">结束排队</button>
          <button class="save" @click="startQueue" v-show="lineUpStatus">开始排队</button>
        </div>
      </div>
    </div>
    <div class="witness_box" v-else>
      <div class="witness_head">视频双录见证</div>
      <div class="link_info">
        <span>见证人员联系信息</span>
        <span>姓名：{{ seatOpInfo.USER_NAME }}</span>
        <span>座机：{{ seatOpInfo.TEL }}</span>
        <span>联系电话：{{ seatOpInfo.MOBILE_TEL }}</span>
      </div>
      <div class="witness_body">
        <div class="witness_agent">
          <div :class="agentClass" @dblclick="changeViewAgent(agentClass)" id="agent_remote_video"></div>
          <div class="witness_edit">
            <!--<div class="btn" @click="rotate">
	    					<img src="../../assets/images/rotate.png"/>
	    					画面旋转
	    				</div>-->
          </div>
          <div :class="custClass" id="videoRemote" @dblclick="changeViewCust(custClass)" ref="videoRemote"></div>
          <div v-if="isShowTip" class="witness_tip">
            <span>双击视频画面可切换视频窗口</span>
            <svg
              @click="isShowTip = false"
              style="position: absolute;top: 0;right: 0;cursor: pointer;"
              t="1637552014092"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2444"
              width="16"
              height="16"
            >
              <path
                d="M507.168 473.232L716.48 263.936a16 16 0 0 1 22.624 0l11.312 11.312a16 16 0 0 1 0 22.624L541.12 507.168 750.4 716.48a16 16 0 0 1 0 22.624l-11.312 11.312a16 16 0 0 1-22.624 0L507.168 541.12 297.872 750.4a16 16 0 0 1-22.624 0l-11.312-11.312a16 16 0 0 1 0-22.624l209.296-209.312-209.296-209.296a16 16 0 0 1 0-22.624l11.312-11.312a16 16 0 0 1 22.624 0l209.296 209.296z"
                p-id="2445"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
        </div>
        <!-- 面见人 -->
        <!-- <div class="witness_preson">
                    <div class="witness_preson-head">
                        <div class="witness_preson-head-icon">
							<img src="../../assets/images/kefufill.png" alt="" srcset="">
						</div>
						<div style="margin-left:0.04rem" class="witness_preson-head-span">见证人员</div>
					</div>
				  <div class="witness_preson-main">
                       <div class="witness_preson-main-box">
                          <div><img src="../../assets/images/examine/custImgEx.png" alt="" srcset=""></div>
					   </div>
				  </div>
				</div> -->
      </div>
    </div>
 
  </div>
</template>
<script>
/* globals anychat,BRAC_Logout,setRotation,GV_ERR_BROWSERNOWEBRTC,requestVideoCall,getRemoteAudioStream,getRemoteVideoStream,BRAC_SetUserStreamInfo,BRAC_STREAMINFO_AUDIOFLAG,
BRAC_SetVideoPos,sdkInit,enterRoom,videoAuthor,Base64,BRAC_UserSpeakControlEx,BRAC_STREAMINFO_VIDEOFLAG,openMedia,closeMedia,leaveRoom,*/

import Util from "@/oldCode/commonTools/util";
import oppService from "@/service/opp-service";
import date from "@/tools/date";
import {checkImgAndVideo } from "@/service/image-service";

export default {
  data () {
    return {
      isShowCollection: false,
      collectionListArr: [],
      newOpenAccType: "", //非现场开户类型
      isEndFlag: false, //是否请求完
      isShowTip: true,
      agentClass: "agent_remote_video",
      custClass: "cust_window",
      timer: {
        "background-image": "url(" + require("@img/oldCode/witness02.png") + ")",
        width: "2rem",
        height: "2rem",
        "background-size": "100% auto"
      },
      inLineTime: 0,
      lineUpStatus: false,
      chatContents: [
        {
          userType: 1,
          message: "你好"
        },
        {
          userType: 2,
          message: "你好"
        },
        {
          userType: 1,
          message: "你好，想向你咨询一下xx方面的业务。"
        },
        {
          userType: 2,
          message: "你好！可以的，您是想要了解哪方面的业务信息呢，我们这边有xxxxxxx和xxxx产品。"
        },
        {
          userType: 1,
          message: "你好"
        },
        {
          userType: 2,
          message: "你好"
        }
      ],
      isReviewPass: false,
      mSelfUserId: "", //客户ID
      agentId: "", //坐席ID
      witnessFlag: false, //是否进行视频见证过程
      witnessCustInfo: {}, //排队签入所需参数
      rotation: 0, //旋转角度
      CUST_INFO: {},
      LEGAL_INFO: {},
      msg: {}, // 视频信息
      witnessesLinkInfo: [],
      //通过坐席人员操作员编号，查询一站通操作员信息
      seatOpInfo: {},
      //坐席人员id
      seatid: "",
      loading : false,
      postConfig : { //向排队服务器发起post请求的axios的配置
        baseURL: "/api",
        timeout: 3000,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-Wit" : "XMLHttpRequest",
          "X-Forwarded-For" : window.clientIp,
          "token": "",
        },
        withCredentials: false,
      },
      videowspwebsocket : "",
      videowspUrl : "",
      serverIp : "",
      appId : "",
      serverPort : "",
    };
  },
  props:["collectionList","microphone","camera", "isOpenMode"],
  watch: {
    loading (v) {
      if (v) {
        this.myLoading({
          
          loadingText: "正在初始化视频服务&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    },
  },
  computed: {
    tradeCode () {
      return this.$store.state.apptSn;
    },
    userInfo () {
      return this.$storage.getJsonSession(this.$definecfg.USER_INFO);
    },
    B_SNO () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    openAccType () {
      return this.$store.state.openAcctType;
    },
    states () {
      return this.$store.state.apptStatus;
    },
    BUSI_INFO (){
      return this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
    },
    BUSI_CODE (){
      return this.$storage.getSession(this.$definecfg.BUSI_CODE);
    },
    CUSTOMER_INFO (){
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO);
    },
    chromeVersion () {
      let browser = Util.getOSAndBrowser(), browserNum = "";
      if (browser.indexOf("Chrome") !== -1) {
        let info = browser.split("/")[1].replace("Chrome", "");
        browserNum = parseInt(info);
      } else {
        browserNum = "90";
      }
      return browserNum;
    }
  },
  mounted () {
    let that = this;
    this.collectionListArr = this.collectionList;

    return  Promise.all([
      that.$syscfg.getSysConfig("FXC_WITNESSES_LINK_INFO"), //获取系统公共参数里面见人信息
      that.$syscfg.getSysConfig("CM_AES_256_CBC_KEY"),//获取cmKey的系统公共参数
      that.$syscfg.getSysConfig("FXC_ANYCHAT_CONFIG"),
    ]).then(res=>{
      that.getSysWitnesses(_.get(res,"[0].Data[0]", {}));
      that.$storage.setSession("CM_KEY", _.get(res, "[1].Data[0].PAR_VAL", ""));
      let anychatConfig = _.get(res,"[2].Data[0].PAR_VAL","");
      if(!anychatConfig){
        that.alert("未取到anychat配置，请联系管理员！");
        return;
      }
      anychatConfig = anychatConfig.split("|");
      that.videowspwebsocket = anychatConfig[0];
      that.serverIp = anychatConfig[1];
      that.appId = anychatConfig[3];
      that.serverPort = anychatConfig[2];
      that.videowspUrl = anychatConfig[4];
      
      if (!Util.global.IS_CHROME) {
        that.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: false,
        });
        that.alert("当前浏览器不支持录像操作，请使用谷歌浏览器！");
        return;
      }
      // if (that.states < 4 || that.states == 11 || that.states == 13) {
      //   that.alert("当前状态不允许进行视频见证操作！");
      //   that.$emit("changeStep", {
      //   type: "startWitness",
      //   isShowCollection: false,
      // });
      //   return;
      // }
      that.witnessCustInfo ={
        BUSI_CODE:  this.BUSI_CODE,
        BUSI_NAME:that.BUSI_INFO.BUSI_NAME || "非现场机构开户",
        B_SNO: that.B_SNO,
        ID: that.B_SNO,
        PROCESS_ID: that.B_SNO,
        ID_CODE: that.BUSI_INFO.BIZ_DATA.KEY_INFO.NEW_ID_CODE ,
        CHANNEL: "channel",
        ORG_CODE_TEXT: that.BUSI_INFO.CUST_ORG_FULL_NAME,
        NAME:that.BUSI_INFO.BIZ_DATA.KEY_INFO.NEW_CUST_NAME,
        UPDATE_TIMESTAMP: date.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
        BUSI_FLAG: that.BUSI_INFO.BUSI_FLAG,
      };
      setTimeout(() => {
        that.initWebsocket();
      }, 1000);
      if (anychat) {
        BRAC_Logout();
      }
      that.lineUpTimer();
      that.timerCheckKeep = setInterval(() => {
        that.getCheckKeep();
      }, 60 * 1000);
      that.alert( that.openAccType == 3 ? "请您签署《开户申请表》、《开户文件》等文件，如您新开立证券账户的，请签署《证券账户开立申请表》，如同时开通相关交易权限，请一并签署相关业务申请表。" : "请您提前准备好《开户申请表》、《证券账户开立申请表》（如有），以上业务表单需在视频见证环节完成签署。");
    }).catch(err=>{
      consoleLog("请求失败", err);
    });
  },
  beforeDestroy () {
  },
  methods: {
    closeCollectionList (){
      this.isShowCollection = false;
    },
    //画面切换
    changeViewAgent (curCAlss) {
      if (curCAlss == "agent_remote_video") {
        this.agentClass = "agent_remote_video1";
        this.custClass = "cust_window1";
      }
      if (curCAlss == "agent_remote_video1") {
        this.agentClass = "agent_remote_video";
        this.custClass = "cust_window";
      }
    },
    changeViewCust (curCAlss) {
      if (curCAlss == "cust_window") {
        this.custClass = "cust_window1";
        this.agentClass = "agent_remote_video1";
      }
      if (curCAlss == "cust_window1") {
        this.custClass = "cust_window";
        this.agentClass = "agent_remote_video";
      }
    },
    //屏幕旋转
    rotate () {
      if (this.flagRotation) {
        return;
      }
      this.flagRotation = true;
      this.rotation += 90;
      if (this.rotation >= 360) {
        this.rotation = 0;
      }
      setRotation({
        userId: this.agentId,
        rotation: this.rotation
      });
      setTimeout(() => {
        this.flagRotation = false;
      }, 500);
    },
    //每分钟去通讯下，去校验anychat的服务有没有挂？
    getCheckKeep () {
      this.$syscfg.K_Request("F0000065",{}).then(res=>{
        consoleLog("anychat keep",res);
        return true;
      });
    },
    initAnychatSdk () {
      var errorcode = sdkInit({
        appId: this.appId,
        serverIp: this.serverIp,
        serverPort:this.serverPort,
        nickName: Util.getCode(4) + "-" + Util.getCode(6),
        onDisConnect: this.onDisConnect,
        onLogin: this.onLogin,
        onReceiveBuffer: this.onReceiveBuffer,
        onReceiveVideoCallStart: this.onReceiveVideoCallStart,
        onReceiveVideoCallError: this.onReceiveVideoCallError,
        onReceiveVideoCallFinish: this.onReceiveVideoCallFinish
      });
      if (errorcode == GV_ERR_BROWSERNOWEBRTC) {
        //浏览器不支持webRTC
        this.loading = false;
        this.alert("您的浏览器不支持webRTC：");
      } else if (errorcode != 0) {
        this.loading = false;
        this.alert("您的浏览器不支持AnyChat：");
      }
    },
    //登录的回调
    onLogin (dwUserId, errorcode) {
      if (errorcode == 0) {
        consoleLog("登录成功，用户名" + dwUserId);
        this.mSelfUserId = dwUserId;
        requestVideoCall({
          userId: this.agentId,
          done: this.onRequestVideoCallDone
        });
      } else if (errorcode == 201) {
        consoleLog("重复登录！");
        this.loading = false;

      } else {
        consoleLog("登录失败！");
        this.loading = false;

      }
    },
    //连接服务器的回调
    onDisConnect (result) {
      if (result.code == 0) {
        consoleLog("退出成功");
      } else {
        consoleLog("连接出错，错误码：" + result.code + ";错误描述:" + result.msg);
        this.loading = false;
      }
    },
    //用户进出房间通知事件
    onRoomUserInAndOut (dwUserId, action) {
      var tips = action == 1 ? "进入房间" : "退出房间";
      consoleLog(dwUserId, this.agentId, "0000000");
      if (dwUserId == this.agentId && action == 0) {
        this.anychatLogout(); //释放资源
        this.websocket.close();
        this.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: true,
        });
        this.loading = false;
      }
    },
    //用户发送消息通知
    onAnyChatUserMsgAtRoom (data) {},
    //接收视频呼叫请求
    onReceiveVideoCallRequest (data) {},
    //接收视频呼叫开始通知
    onReceiveVideoCallStart (data) {
      this.witnessFlag = true;

      this.inLineTime = 0;
      clearInterval(this.timers);
      this.lineUpStatus = true;
      this.findbyCodequeryInfo();
      consoleLog("视频呼叫开始通知，系统分配房间号：" + data.roomId);
      enterRoom({
        roomId: data.roomId,
        password: "",
        done: this.onAnyChatEnterRoom,
        onRoomUserInAndOut: this.onRoomUserInAndOut
      });
    },
    //接收视频呼叫结束通知
    onReceiveVideoCallFinish (event, data) {
      if (this.websocket) {
        this.websocket.close();
      }

      this.anychatLogout();
      this.isShowCollection = true;
      consoleLog("接收视频呼叫结束通知", event, data);
      this.witnessFlag = false;
      this.seatOpInfo = {};
      this.seatid = "";

      if(!this.isReviewPass){
        this.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: false,
        });
      }
    },
    //接收视频呼叫异常通知
    onReceiveVideoCallError (result) {
      consoleLog("接收视频呼叫异常通知", result);
      if (this.websocket) {
        this.websocket.close();
      }
      this.witnessFlag = false;
      this.seatOpInfo = {};
      this.seatid = "";
    },
    //呼叫目标用户回调
    onRequestVideoCallDone (result, data) {
      consoleLog("呼叫目标用户回调", result, data);
    },
    //进入房间的回调
    onAnyChatEnterRoom (dwRoomId, errorcode) {
      this.loading = false;
      if (errorcode == 0) {
        //进入房间成功
        oppService.updateApptStatus(this.$store.state.apptSn, "8");
        videoAuthor({ done: this.OnAnyChatMediaAuthority });
      }
    },
    //获取媒体权限的回调
    OnAnyChatMediaAuthority (errorcode, res) {
      let isOpenModeParam =  this.isOpenMode || false;
      if(this.isOpenMode === ""){
        if(this.chromeVersion == 114 || parseInt(this.chromeVersion) >= 126){
          isOpenModeParam = true;
        }
      }
      
      if (errorcode == 0) {
        openMedia({
          userId: this.mSelfUserId,
          videoId: document.getElementById("videoRemote"),
          width: 640,
          height: 480,
          done: this.OnAnyChatH5MediaOpenStatus,
          chooseCamera: this.camera,
          chooseMicrophone: this.microphone,
          isOpenMode: isOpenModeParam,
        });
        getRemoteAudioStream(this.agentId);
        getRemoteVideoStream({
          userId: this.agentId,
          demoId: "agent_remote_video",
          width: 320,
          height: 240
        });
      } else {
        consoleLog("获取媒体授权失败： " + errorcode);
        this.alert("获取媒体授权失败！");
      }
    },
    //H5媒体状态，wParam（INT）表示媒体开启状态成功与否，0 成功, -1 失败， lParam（string） 表示错误信息
    OnAnyChatH5MediaOpenStatus (errorcode, res) {
      consoleLog("H5媒体状态", errorcode, res);
    },
    //OPPCP-22462 需求 通过视频见证人员操作员编号，查询一站通操作员信息
    async findbyCodequeryInfo () {
      let param = {
        USER_CODE: this.seatid //this.seatid
      };
      let  res = await this.$syscfg.K_Request("F0000067", param);
      if (res.Code == "0") {
        let seatInfo = res.Data[0];
        this.seatOpInfo = { ...seatInfo };
      }
    },
    alertMsgAndCloseAnychat (text){
      this.alert(text);
      this.anychatLogout(); //释放资源
      if (this.websocket) {
        //解决js报错
        this.websocket.close();
      }
      //给1s时间释放资源 后 返回重新见证
      setTimeout(() => {
        this.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: false,
        });
      }, 1000);
    },
    async switchVideo (msg) {
      this.isEndFlag = false;
      switch (msg.TRANS_TYPE) {
        //机器人初始化完成
        case "00":
          //OPPCP-27477 视频能力平台支持新客户端 --解决见证端没有听到话术问题
          BRAC_SetUserStreamInfo(msg.aiUserid, 0, BRAC_STREAMINFO_AUDIOFLAG, 1);
          BRAC_SetUserStreamInfo(msg.aiUserid, 0, BRAC_STREAMINFO_VIDEOFLAG, 0);
          BRAC_UserSpeakControlEx(msg.aiUserid, 1, 0, 0, "");
          BRAC_SetVideoPos(msg.aiUserid, document.getElementById("agent_remote_video") ,"ANYCHAT_VIDEO_videoDiv_AI");
          consoleLog("机器人初始化完成");
          break;
        //审核视频保存
        case "01":
          consoleLog("保存视频",msg);
          break;
        //审核通过影像信息资料
        case "02":
          /*
						   1，检查是否丢失免冠照或者视频；如果丢失则通知后台补数据
						   2，如果没丢失，则改变状态

						*/

          //判断是否有免冠照、见证视频
          let res = await checkImgAndVideo(this);
          if (res.flagImg) {
            // 免冠照丢失通知后台补数据
            // this.$api.post(getVideoImg, { thirdBusinessNo: msg.B_SNO, tradeCode: tradeCode }); //使用接口获取到的实时非现场流水号
            this.alertMsgAndCloseAnychat("免冠照未保存成功，请重新见证。");
          } else if (res.flagVideo) {
            //见证视频未保存成功，提示错误，并退出组件重新录制
            this.alertMsgAndCloseAnychat("见证视频未保存成功，请重新见证。");
          } else {
            //坐席端提交后，缓存里用于控制重复调用保存视频参数清空
            await oppService.updateApptStatus(this.$store.state.apptSn, "9");
            //保存见证节点时间
            await this.$syscfg.K_Request("F0000069", {
              APPT_SN: this.$store.state.apptSn,
              VIDEOREVIEWDATE : date.getClientDateTime("yyyy-MM-dd hh:mm:ss"),
            });
            this.isReviewPass = true;
            setTimeout(() => {
              this.$emit("changeStep", {
                type: "startWitness",
                isShowCollection: true,
              });
            }, 1000);
          }
          break;
        //审核驳回
        case "03":
          let partData03 = {
            name: "双向见证接受到审核驳回通知准备发送请求",
            params: msg
          };
          // this.$store.dispatch("getClientLog", partData03);
          // this.getUploadVideo(this.msg, "03");
          //两个视频，需要取透明通道传过来的入参
          // this.getUploadVideo(msg, "03");
          clearTimeout(this.timerBuffer);
          this.timerBuffer = setTimeout(() => {
            this.alert( "视频见证不通过，驳回原因：" + msg.AUDIT_REMARK);
            this.$emit("changeStep", {
              type: "startWitness",
              isShowCollection: false,
            });
          }, 300);
          break;
        //现场照
        case "05":
          clearTimeout(this.timerBuffer);
          if (msg.IMG_PATH.startsWith("http:") || msg.IMG_PATH.startsWith("https:")) {
            let partData05 = {
              name: "双向见证接受到现场照通知准备发送请求",
              params: msg
            };
            // this.$store.dispatch("getClientLog", partData05);
            // this.getUploadVideo(msg);
          }
          break;
        //上传面见人
        case "06":
          // //坐席端提交后，缓存里用于控制重复调用保存视频参数清空   -----坐席端点击 录制--停止---录制，需要清空缓存

          break;
        //视频见证信息
        // case '07':

        // 	break;
      }
    },
    //透明通道
    async onReceiveBuffer (data) {
      //写入日志
      let partData = {
        name: "双向见证接受到透明通道通知",
        params: msg
      };
      // this.$store.dispatch("getClientLog", partData);
      consoleLog("收到透明通道消息11111：", data);
      let msg = data.msg;

      // consoleLog(msg.TRANS_TYPE, '免冠照');
      consoleLog("isEndFlag:", this.isEndFlag);
      if (!this.isEndFlag) {
        setTimeout(() => {
          this.switchVideo(msg);
        }, 1000);
      } else {
        this.switchVideo(msg);
      }
    },
    initWebsocket () {
      let wsUrl = this.videowspwebsocket + this.B_SNO;
      let partData = {
        name: "wsUrl详情",
        params: wsUrl
      };
      consoleLog(partData);
      // this.$store.dispatch("getClientLog", partData);
      this.websocket = new WebSocket(wsUrl);
      this.websocket.onopen = this.onopen;
      this.websocket.onmessage = this.onmessage;
      this.websocket.onclose = this.onclose;
      this.websocket.onerror = this.onerror;
      this.isReviewPass = false;
    },
    //websocket连接
    onopen (e) {
      consoleLog("websocket 连接成功");
      setTimeout(() => {
        this.doCheckIn();
      }, 1000);
    },
    //监听数据
    onmessage (msg) {
      let data = msg.data || {};
      console.log("获取数据：", JSON.parse(data), anychat);
      try {
        data = JSON.parse(data);
        switch (data.code) {
          case 208: //得到坐席ID
            this.agentId = data.body.anychatid;
            this.loading = true;

            //loading框
            this.initAnychatSdk();
            break;
          case 103: //客户挂机  清除排队客户相关资料
            break;
          case 108: //坐席服务队列超时挂机(坐席没有应答)  清除排队客户相关资料
            break;
          case 107: //坐席服务队列超时挂机(坐席没有应答)  清除排队客户相关资料
            break;
          case 151:
            this.seatid = data.body.seatid; //座席端id
            break;
        }
        //心跳响应
        if (data.body.code === "226") {
          console.log("心跳响应： " + JSON.stringify(data));
        }
      } catch (e) {
        console.log(e);
      }
    },
    //监听关闭
    onclose (e) {
      consoleLog("websocket关闭连接", e);
      this.websocket = null;
      if (anychat) {
        this.anychatLogout();
      }
      clearInterval(this.wsHeartTimer);
    },
    onerror (e) {
      consoleLog("websocket连接失败", e);
      clearInterval(this.wsHeartTimer);
    },
    //签入
    async doCheckIn () {
      if (!this.witnessCustInfo) {
        this.alert("机构信息读取失败！");
        this.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: false,
        });
        return;
      }
      let body = {
        name: this.B_SNO,
        publicUserId: "web_00000001",
        priority: 1,
        hjlsh: "77077",
        flag: "2", //0主动分配 2抢单模式
        action: "0",
        devicetype: "pc",
        custinfo: JSON.stringify(this.witnessCustInfo),
        grapAllocations: [
          {
            //flag为2时主动模式用
            group: "QS420"
          }
        ]
      };
      body = Util.getAes256Data(JSON.stringify(body)); // 按要求加密过程
      let data = {
        code: 101,
        body: body,
        channel: "channel",
        extInfo: JSON.stringify({}),
        tradeCode: this.tradeCode,
      };
      let res = await this.$syscfg.K_Request_Post(this.videowspUrl + this.B_SNO, data, Object.assign({}, this.postConfig, {tradeCode: this.tradeCode})); //发起预录入

      if (res.data.errcode != 0) {
        this.$emit("changeStep", {
          type: "startWitness",
          isShowCollection: false,
        });
        this.alert({
          content: res.data.errmsg || "连接失败，请重试！",
          duration: 5
        });
      } else {
        if (this.wsHeartTimer) {
          clearInterval(this.wsHeartTimer);
        }
        this.wsHeartTimer = setInterval(() => {
          this.websocketHeartBeat(res.data.body.token);
        }, 30 * 1000);
      }
    },
    //发送websocket心跳
    websocketHeartBeat (token) {
      let data = {
        code: "116",
        channel: "anychat",
        token: token,
        body: {}
      };
      this.websocket && this.websocket.send(JSON.stringify(data));
    },

    //参数加密
    imgclsEncode (val) {
      if (val.startsWith("http:") || val.startsWith("https:")) {
        let str = val;
        let base = new Base64();
        let result = base.encode(str);
        return result;
      } else {
        return val;
      }
    },
    transformTime (s) {
      var t;
      if (s > -1) {
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;
        if (min < 10) {
          t = "0" + min + ":";
        } else {
          t = min + ":";
        }
        if (sec < 10) {
          t += "0";
        }
        t += sec;
      }
      return t;
    },
    showLoad (s) {
      return Math.floor(s % 5);
    },
    lineUpTimer () {
      this.inLineTime = 0;
      this.timers = setInterval(() => {
        this.inLineTime++;
        if (this.lineUpStatus) {
          clearInterval(this.timers);
        }
      }, 1000);
    },
    endQueue () {
      consoleLog("结束排队");
      this.inLineTime = 0;
      clearInterval(this.timers);
      this.lineUpStatus = true;
      if (this.websocket) {
        //解决js报错
        this.websocket.close(); //断开websocket连接
      }
      this.$emit("changeStep", {
        type: "startWitness",
        isShowCollection: false,
      });
    },
    startQueue () {
      consoleLog("开始排队");
      this.lineUpStatus = false;
      this.lineUpTimer();

      this.initWebsocket(); //重新连接websocket
    },
    //获取系统参数---见证人员联系信息
    async getSysWitnesses (sysWitnessesInfo) {
      //FXC_WITNESSES_LINK_INFO 一站通系统参数(非现场见证人员联系信息)
      if(sysWitnessesInfo && sysWitnessesInfo.PAR_VAL){
        let infoArr = sysWitnessesInfo.PAR_VAL.split(";");
        infoArr.forEach(key => {
          let infoObj = key.split(",");
          this.witnessesLinkInfo.push({
            NAME: infoObj[0],
            TEL: infoObj[1],
            MOBILE_TEL: infoObj[2]
          });
        });
      }
    },
    anychatLogout () {
      if (anychat) {
        closeMedia();
        leaveRoom();
        BRAC_Logout();
      }
    }
  },
  destroyed () {
    if (this.timerCheckKeep) {
      clearInterval(this.timerCheckKeep);
    }
    if (this.websocket) {
      this.websocket.close(); //断开websocket连接
    }
    this.anychatLogout();
  }
};
</script>
<style >
#videoRemote video {
  position: absolute;
  width: 100%;
  transform: translateX(-50%) translateY(-50%);
  left: 50%;
  top: 50%;
}
#agent_remote_video video {
  position: absolute;
  width: 100%;
  transform: translateX(-50%) translateY(-50%);
  left: 50%;
  top: 50%;
}
</style>
<style lang="less" scoped>
.LineUpContainer{
  width: 15rem;
  max-width: 15rem;
  padding: 0 !important;
  height: 100% !important;
  .white-box{
    height: 100%;
    .queue{
      .save {
        margin-bottom: 0.2rem;
        height: 40px;
      }
      .rigCon {
        display: flex;
        align-items: center;
        flex-direction: row;
        font-size: 0.14rem;
        color: #333333;
        // margin-left: 4.5rem;
        width: 100%;
        justify-content: center;
        position: relative;
        margin: 0 auto;
        .con-left {
          width: 6rem;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          .timer {
            text-align: center;
            line-height: 2rem;
            font-size: 0.36rem;
            color: #ffffff;
            margin-top: 1.24rem;
          }
          .inLine {
            margin-top: 0.5rem;
            margin-bottom: 0.34rem;
            font-size: 0.16rem;
          }
        }
        
        .con-right{
          // width: 6.5rem;
          position: absolute;
          right: 0;
          width: 5rem;
          .help-head {
            font-size: 0.16rem;
            margin-bottom: 0.1rem;
          }
          .help-body{
              ul{
                li{
                  span {
                    display: inline-block;
                    width: 1.2rem;
                    font-size: 0.14rem;
                  }
                  .help-name{
                    width: 0.8rem;
                  }
                }
                .li-title{
                  span{
                    font-weight: 600;
                    width: 1rem;
                  }
                  .help-name{
                    width: 0.8rem;
                  }
                }
              }
          }
        }
      }
    }
  }
  .witness_box{
    background: #ffffff;
    background: #ffffff;
    border-radius: 8px;
    .witness_head {
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      font-size: 0.26rem;
      color: #333333;
      border-bottom: 0.5px solid #eaedf3;
    }
    .witness_body {
      padding: 0.1rem 0.3rem;
      clear: both;
      overflow: hidden;
      position: relative;
      .witness_agent {
        width: 12.5rem;
        margin: 0 auto;
        background-color: #000000;
        position: relative;
        .witness_edit {
          height: 0.6rem;
          background: #000000;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .witness_tip {
          position: relative;
          width: 3.5rem;
          margin: 0 auto;
          border: 1px solid #cccccc;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          border-radius: 3px;
          text-align: center;
          margin-top: -0.45rem;
        }
      }
    }
    .link_info {
      display: flex;
      padding-top: 0.1rem;
      justify-content: center;
      font-size: 0.14rem;
      span {
        padding: 0 0.3rem;
      }
    }
  }
}

.agent_remote_video {
  height: 6.5rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.agent_remote_video1 {
  height: 1.7rem;
  width: 2.6rem;
  position: absolute;
  overflow: hidden;
  right: 0.2rem;
  bottom: 0.8rem;
  border-radius: 5px;
  cursor: pointer;
  z-index: 200;
}

.witness_edit .btn {
  width: 1.2rem;
  height: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  border: 0.5px solid #ffffff;
  border-radius: 5px;
  margin-right: 0.2rem;
}
.witness_edit .btn img {
  width: 0.18rem;
  height: 0.18rem;
  margin-right: 5px;
}
.cust_window {
  height: 1.7rem;
  width: 2.6rem;
  position: absolute;
  overflow: hidden;
  right: 0.2rem;
  bottom: 0.8rem;
  border-radius: 5px;
  cursor: pointer;
}
.cust_window1 {
  height: 7.1rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  bottom: 0.6rem;
  cursor: pointer;
}

@media screen and (max-width: 1440px) {
  .witness_edit .btn {
    font-size: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/lineUp.vue